import { defineComponent, computed, createElementBlock, openBlock, normalizeStyle, createCommentVNode, mergeProps } from 'vue';

const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  key: 1,
  class: "media-iframe"
};
const _hoisted_3 = ["src"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaIframe",
  props: {
    media: {}
  },
  setup(__props) {
    const props = __props;
    const style = computed(() => {
      const style2 = {
        width: props.media.width !== -1 ? `${props.media.width}px` : "100%",
        height: props.media.height !== -1 ? `${props.media.height}px` : "100%"
      };
      return style2;
    });
    const aspectStyle = computed(() => {
      const aspect = (props.media?.aspectRatio || "1:1").replace(":", "/");
      return {
        ...style,
        "--aspect-ratio": aspect
      };
    });
    const customArgs = computed(() => {
      if (props.media.customArgs) {
        return props.media.customArgs;
      }
      return {};
    });
    return (_ctx, _cache) => {
      return _ctx.media.html ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "media-iframe media-iframe--html",
        style: normalizeStyle(aspectStyle.value),
        innerHTML: _ctx.media.html.trim()
      }, null, 12, _hoisted_1)) : (openBlock(), createElementBlock("div", _hoisted_2, [
        _ctx.media.url ? (openBlock(), createElementBlock("iframe", mergeProps({
          key: 0,
          src: _ctx.media.url,
          style: style.value
        }, customArgs.value), null, 16, _hoisted_3)) : createCommentVNode("", true)
      ]));
    };
  }
});

export { _sfc_main as default };
